import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../settings/withDirection';

export const Title = styled('div')`
  font-family: Helvetica;
  font-size: 14px;
  letter-spacing: 0.35px;
  color: ${palette('grayscale', 0)};
  font-weight: 600;
  margin: 6px 0 6px 0;
`;

export const Countries = styled('div')`
  padding: 0;
  margin: 0;
  min-width: 180px;
  width: 100%;
`;

const CountryButton = styled('button')`
  color: ${palette('grayscale', 0)};
  display: flex;
  align-items: center;
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  border: 0;
  padding: 0;
  background: transparent;
  width: 100%;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    color: ${palette('secondary', 0)};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: default;
    color: ${palette('grayscale', 0)};
  }

  img {
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '5px' : '0')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '5px')};
  }
`;

export const CountryImageWrapper = WithDirection(styled('div')`
  display: flex;
  position: relative;

  i {
    width: 10px;
    height: 10px;
    position: absolute;
    color: ${palette('success', 0)};
    background: white;
    border-radius: 100%;
    font-size: 10px;
    right: 0;
    bottom: -4px;
  }

  .notification-badge {
    right: ${props => (props['data-rtl'] === 'rtl' ? 'initial' : '1px')};
    left: ${props => (props['data-rtl'] === 'rtl' ? '1px' : 'initial')};
  }
`);

export const SpinWrapper = styled('div')`
  margin-top: 6px;
`;

export const CountryImage = styled('div')`
  margin-right: 5px;
  display: inline-flex;
  align-items: center;

  svg {
    width: 23px;
    height: auto;
  }
`;

export const Wrapper = styled('div')`
  position: relative;
  display: flex;

  svg {
    width: 23px;
    height: auto;
  }
`;

export default WithDirection(CountryButton);
